import React from 'react';
import {IProduct} from 'data/interfaces/products';
import HotelInfo from './components/hotelInfo';
import PlaceDetailsCard from '../../../../../commons/placeDetailsCard';

interface IHotelDetailsCardProps {
  product?: IProduct;
}

const HotelDetailsCard = (props: IHotelDetailsCardProps) => (
  <PlaceDetailsCard infoComponent={HotelInfo}
                    mobileTitle={"פרטי מלון"}
                    toolTip="מלון"
                    product={props.product}
  />
);


HotelDetailsCard.defaultProps = {};

export default React.memo(HotelDetailsCard);
